jQuery(document).ready(function($) {

  let postOffset = 12, category = [8,6,7,14,11];
  let blog = $('div.blog'),
    loadButton = $('.loading-post-click'),
    canBeLoaded = true;

  category = $('.filter_list-header').attr('data-id');

  if (blog.length) {

    $( '.loading-post-click' ).click(function() {       
      $.ajax({
        type: 'POST',
        url: ajax.url,
        data: {
          action: 'load_more_posts_ajax',
          category: category,
          offset: postOffset,
        },
        beforeSend: function() {
          canBeLoaded = false;
        },
        success: function(response) {

          let data = JSON.parse(response);
          postOffset += 12;
         
          if (data.html) {
            $('body').addClass('loaded-posts');           
            $(data.html).hide().appendTo('.blog-show-more .post-list').fadeIn(1500);
            
            canBeLoaded = !data.hide_load_more;
          
            if(!canBeLoaded) {
              loadButton.addClass('display-none');
            }
            else {
              loadButton.removeClass('display-none');
            }
          }
        },
      });      
    });
  }

  $('.filter_list').click(function() { 
    $(this).toggleClass('active');
  });

});

